import { render, staticRenderFns } from "./ColaboradorSecondStep.vue?vue&type=template&id=6389608b&scoped=true&"
import script from "./ColaboradorSecondStep.vue?vue&type=script&lang=js&"
export * from "./ColaboradorSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradorSecondStep.vue?vue&type=style&index=0&id=6389608b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389608b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VCombobox,VForm,VRow,VTextField})
